/**
 * @generated SignedSource<<ea7061413f8ed1ede238f78fcb3b8347>>
 * @relayHash 4484fadd23c040a81eec65da02ab0cd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4

import type { ConcreteRequest } from 'relay-runtime';
export type usePageTreeSearchQueryQuery$variables = {
  spaceKey: string;
  title: string;
  validateSpace: boolean;
};
export type usePageTreeSearchQueryQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space?: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type usePageTreeSearchQueryQuery = {
  response: usePageTreeSearchQueryQuery$data;
  variables: usePageTreeSearchQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "validateSpace"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "id"
  }
],
v2 = [
  {
    "condition": "validateSpace",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "page"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": (v1/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePageTreeSearchQueryQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePageTreeSearchQueryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4484fadd23c040a81eec65da02ab0cd9",
    "id": "8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4",
    "metadata": {},
    "name": "usePageTreeSearchQueryQuery",
    "operationKind": "query",
    "text": "query usePageTreeSearchQueryQuery($spaceKey:String!,$title:String!,$validateSpace:Boolean!){space(key:$spaceKey)@include(if:$validateSpace){id},content(spaceKey:$spaceKey,title:$title,type:\"page\"){nodes{id}}}"
  }
};
})();

(node as any).hash = "1be6e27ce1b78f4f22a3ff6689bbf9e4";

export default node;
